import SavedPage from './SavedPage.js';

const  PageScript =  {
  init() {
    SavedPage.init();
  }
}

export default PageScript;